import { NgModule } from '@angular/core';
import { PhoneInputComponent } from './phone-input.component';
import { DropdownModule } from '@app/modules/ui/dropdown/dropdown.module';
import { ReactiveFormsModule } from '@angular/forms';
import { RegexPipeModule } from '@app/modules/ui/pipes/regex/regex.module';
import { PhoneNumberDirective } from '@app/modules/ui/phone-input/phone-number.directive';
import { NgClass } from '@angular/common';
import { IconsStandaloneComponent } from '@app/shared/modules/icons/components/icon-standalone/icon.component';
import { TranslateModule } from '@app/shared/modules/translate/translate.module';

@NgModule({
  imports: [DropdownModule, ReactiveFormsModule, RegexPipeModule, NgClass, IconsStandaloneComponent, TranslateModule],
  declarations: [PhoneInputComponent, PhoneNumberDirective],
  exports: [PhoneInputComponent, PhoneNumberDirective]
})
export class PhoneInputModule {}
